import { render, staticRenderFns } from "./money-view.vue?vue&type=template&id=df43d4e2&"
import script from "./money-view.vue?vue&type=script&lang=ts&"
export * from "./money-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports